// latest: zhangmyh 2017-6-7 11:13 AM
import { Get, URLs } from 'common'
import './index.less'
/* global $ ko u */

/* eslint-disable */
let _config
/* eslint-enable */
function init (refer) {
  let rootList = []
  Get(URLs.address_province.url).then(function (data, state) {
    if (state.toLowerCase() === 'success') {
      let list = data.map(function (o) {
        return {
          id: o.provinceID,
          text: o.provinceName
        }
      })
      rootList = list
      vm.list(rootList)
    }
  })
  let info = refer.options.area
  if (!info) {
    info = {}
  }
  let vm = {
    index: ko.observable('province'),
    step: ko.observable(0),
    list: ko.observableArray([]),
    province: ko.observable(info.provinceId || null),
    provinceName: ko.observable(info.provinceName || '未选择'),
    city: ko.observable(info.cityId || null),
    cityName: ko.observable(info.cityName || '未选择'),
    district: ko.observable(info.districtId || null),
    districtName: ko.observable(info.districtName || '未选择'),
    changeArea (id, name) {
      const type = this.index()
      if (type == 'province') {
        this.chooseCity(id, name)
      } else if (type == 'city') {
        this.chooseDistrict(id, name)
      } else if (type == 'district') {
        this.confirm(id, name)
      }
    },
    chooseProvince () {
      if (this.index() != 'province') {
        this.index('province')
        this.list(rootList)
      }
    },
    chooseCity (province, name) {
      if (this.index() == 'city') {
        return
      }
      if (this.initOver && _config.type == 'province') {
        this.province(province)
        this.provinceName(name)
        this.city(null)
        this.cityName(null)
        this.district(null)
        this.districtName(null)
        refer.submit()
        return
      }
      if (!province || typeof province == 'object') {
        province = this.province()
      } else {
        this.province(province)
        this.provinceName(name)
        this.city(null)
        this.cityName('未选择')
        this.district(null)
        this.step(1)
      }
      this.index('city')
      let t = this
      Get(URLs.address_city.url, { province: province }).then(function (data, state) {
        if (state.toLowerCase() === 'success') {
          t.list(data.map(function (o) {
            return {
              id: o.cityID,
              text: o.cityName
            }
          }))
        }
      })
    },
    chooseDistrict (city, name) {
      if (this.index() == 'district') {
        return
      }
      if (this.initOver && _config.type == 'city') {
        this.city(city)
        this.cityName(name)
        this.district(null)
        this.districtName(null)
        refer.submit()
        return
      }
      if (!city || typeof city == 'object') {
        city = this.city()
      } else {
        this.city(city)
        this.cityName(name)
        this.district(null)
        this.districtName('未选择')
        this.step(2)
      }
      this.index('district')
      let t = this
      Get(URLs.address_district.url, { city: city }).then(function (data, state) {
        if (state.toLowerCase() === 'success') {
          t.list(data.map(function (o) {
            return {
              id: o.districtID,
              text: o.districtName
            }
          }))
        }
      })
    },
    confirm (district, name) {
      this.district(district)
      this.districtName(name)
      if (this.initOver) {
        refer.submit()
      }
    },
    init () {
      if (_config.type == 'city') {
        if (_config.provinceId && _config.provinceName) {
          this.province(_config.provinceId)
          this.provinceName(_config.provinceName)
          this.chooseCity(_config.provinceId, _config.provinceName)
        }
      } else if (_config.type == 'district') {
        if (_config.provinceId && _config.provinceName) {
          this.province(_config.provinceId)
          this.provinceName(_config.provinceName)
          this.chooseCity(_config.provinceId, _config.provinceName)

          if (_config.cityId && _config.cityName) {
            this.city(_config.cityId)
            this.cityName(_config.cityName)
            this.chooseDistrict(_config.cityId, _config.cityName)
          }
        }
      }
      this.initOver = true
    },
    initOver: false
  }

  vm.init()
  let app = u.createApp()
  app.init(vm, $('#area_refer')[0])
  refer.registerSubmitFunc(() => {
    return {
      provinceId: vm.province(),
      provinceName: vm.provinceName(),
      cityId: vm.city(),
      cityName: vm.cityName(),
      districtId: vm.district(),
      districtName: vm.districtName()
    }
  })
}

let template = require('./index.html')
export default function (config) {
  _config = Object.assign({
    type: 'all'
  }, config)
  return {
    init,
    template
  }
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/area/index.js